import { DatePipe } from '@angular/common';
import { Component, OnDestroy, ChangeDetectorRef, Renderer2, Inject, HostListener, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BilletInputConfigModel } from '@model/billet-input-config.model';
import { MarketEnum } from '@model/enum/market.enum';
import { SideEnum } from '@model/enum/side.enum';
import { TypeOrderRequestEnum } from '@model/enum/type-order-send.enum';
import { TypeOrderEnum } from '@model/enum/type-order.enum';
import { SimpleOrder } from '@model/simpleOrder';
import { StatusConnection } from '@model/status-connection';
import { MessageQuote } from '@model/webFeeder/message-quote.model';
import { AuthServer } from '@services/auth-server.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { DailyOrderService } from '@services/webFeeder/sckt-daily-order.service';
import { QuoteService } from '@services/webFeeder/sckt-quotes.service';
import { StatusOmsService } from '@services/webFeeder/sckt-status-oms.service';
import { AppUtils } from '@utils/app.utils';
import { Constants } from '@utils/constants';
import { Subscription, of } from 'rxjs';

@Component({
  selector: 'app-billet-modal-float',
  templateUrl: './billet-modal-float.component.html'
})
export class BilletModalFloatComponent implements OnInit, OnDestroy {

  private subscriptionStatusOms: Subscription;
  private _subscriptionQuote: Subscription;
  private _closedModalBuySell: Subscription;
  dialog: MatDialog;
  whiteLabel = this._configService.getConfigWhitelabel();
  title = Constants.TITLE_CARD_BILLET_WKS;
  timeInForceOptions = Constants.TIME_IN_FORCES;
  msgInvalidAsset = Constants.WORKSPACE_MSG007;
  configInputSimple = Constants.BILLET_WKS_SIMPLE_CONFIG;
  typeOrderOptions = Constants.BILLET_TYPE_ORDER;
  toolTipEngine = Constants.TOOLTIP_ENGINE;
  typeOrderSelected: BilletInputConfigModel = new BilletInputConfigModel();
  configInputStop = this._configService.isTypeBilletStopSimultaneousOrOco() ? Constants.BILLET_WKS_STOP_CONFIG : Constants.BILLET_WKS_STOP_OCO_CONFIG;
  isThemeDark = this._configService.getFavoriteThemeUser();
  showConfirmationBillit: boolean;
  showTermOperator: boolean;
  loading = true;
  model: SimpleOrder = new SimpleOrder();
  messageQuote: MessageQuote = new MessageQuote();
  listPosition: any;
  symbol = '';
  imgName: any;
  loadingImgName: boolean;
  lastTrade: any;
  variation: any;
  coinVariation: any;
  priceTheory: number;
  varTheory: string;
  timeToOpen: string;
  oldPositionSymbol = '';
  oldSymbolTemp: string;
  indiceFuture: boolean;
  auctionHammer: boolean;
  hiddenInvalid: boolean;
  showVariation: boolean;
  loadValueService: boolean;
  tabChangeTypeOrder = 0;
  tabChangeSide = 0;
  strategiesList = [];
  isBilletFloat = true;
  orderStrategy: any;
  loadingStrategies = false;
  hiddenConfirmationBillet = false;
  financialAccount: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    _dialog: MatDialog,
    private _statusOmsService: StatusOmsService,
    private _configService: ConfigService,
    private _cdRef: ChangeDetectorRef,
    private _quoteService: QuoteService,
    private _datePipe: DatePipe,
    private _authServer: AuthServer,
    private _render2: Renderer2,
    private _dailyOrderService: DailyOrderService,
  ) {
    this.dialog = _dialog;
    this.model.side = this.data && this.data.billetType === SideEnum.SELL ? SideEnum.SELL : SideEnum.BUY;
    this._closedModalBuySell = this._configService.modalBuySellClosed$
      .subscribe(closed => {
        if (closed) {
          this.close();
        }
      });
  }

  ngOnInit(): void {
    this.subscriptionOms();
  }

  ngOnDestroy() {
    // TODO: Desabilitado função que carrega os dados da boleta após fecha-lá
    // if (this.model.quote) {
    //   this._configService.setConfigBilletClose(this.model);
    // } else {
    //   this._configService.deleteConfigBilletClose();
    // }
    this.unSubscriptionOms();
    this.unsubscribeQuote();
    if (this._closedModalBuySell) {
      this._closedModalBuySell.unsubscribe();
      this._configService._modalBuySellClosed.next(false);
    }
    this.dialog.closeAll();
  }

  subscriptionOms() {
    this.subscriptionStatusOms = this._statusOmsService.messagesStatusOms
      .subscribe(statusOms => {
        if (statusOms && statusOms === StatusConnection.ERROR) {
          this.callAlert('', Constants.MSG_STATUS_OFFLINE_OMS, Constants.ALERT_TYPE.warn);
          this.loading = false;
          setTimeout(() => {
            this._cdRef.detectChanges();
          }, 500);
        } else {
          this.model.account = this._configService.getBrokerAccountSelected();
          if (this.model.account) {
            this.getFinancialAccount(this.model.account);
          }
          this.getStrategies();
        }
      });
  }

  unSubscriptionOms() {
    if (this.subscriptionStatusOms) {
      this.subscriptionStatusOms.unsubscribe();
    }
  }

  getStrategies() {
    this.loadingStrategies = true;
    this._authServer.iNegotiation.getStrategies()
      .subscribe(res => {
        this.strategiesList = [...res];
        if (this.strategiesList && this.strategiesList.length >= 2) {
          const defaultStrategy = this.strategiesList.findIndex(strategy => strategy.orderStrategy === this.whiteLabel.billet.orderStrategy);
          this.orderStrategy = defaultStrategy !== -1 ? this.strategiesList[defaultStrategy].orderStrategy : null;
        }
        this.loadingStrategies = false;
        this.initBillet();
      }, () => {
        this.loadingStrategies = false;
        this.initBillet();
      });
  }

  initBillet() {
    if (!this.model.account) {
      this.model.account = this._configService.getBrokerAccountSelected();
    }
    this.typeOrderSelected = this.typeOrderOptions[0];
    this.model.type = this.typeOrderSelected.webFeeder;
    this.model.timeInForce = this.timeInForceOptions[0].webfeeder;
    this.model.type = this.model.type === TypeOrderEnum.STOP ? TypeOrderEnum.STOP : TypeOrderEnum.LIMITED;
    this.model.timeInForce = 'DAY';
    this.model.validityOrder = new Date();
    this.model.stopGain = true;
    this.model.stopLoss = true;
    this.model.price = 0;
    this.model.maxfloor = 0;
    this.model.minqtd = 0;
    this.model.orderTag = null;
    this.model.price = this.data && this.data.price ? this.data.price : this.model.price;
    this.model.orderStrategy = this.orderStrategy;
    if (this.data && this.data.quote) {
      this.setQuote(this.data.quote);
    }
    this.variation = 0;
    this.coinVariation = 0;
    this.listPosition = null;
    // TODO: Desabilitado função que carrega os dados da boleta após fecha-lá
    // if (this._configService.getConfigBilletClose()) {
    // this.configBilletClosed = this._configService.getConfigBilletClose();
    // this.setInitialValuesClosedModal(this.configBilletClosed);
    // }
    this.changeTabSide(null, this.model.side);
  }

  getFinancialAccount(account: any) {
    if (account) {
      this.financialAccount = {};
      this._authServer.iNegotiation.financialAccountInformationCompl(this.model.account, Constants.MARKET_BOVESPA)
        .subscribe((res: any) => {
          if (res && res.length > 0) {
            res.forEach(element => {
              this.financialAccount.balanceProjOnline = element.balanceProjOnline.value ? Number(element.balanceProjOnline.value) : '-';
              this.financialAccount.uniqueLimit = element.uniqueLimit.value ? Number(element.uniqueLimit.value) : '-';
            });
          }
          setTimeout(() => { this.loading = false; }, 1000);
        }, () => {
          setTimeout(() => { this.loading = false; }, 1000);
        });
    }
  }

  selectAsset(event) {
    if (this.data) {
      this.data.symbol = event.symbol;
    }
    this.resetQuote();
    if (event.symbol || event.symbol === '') {
      this.model.quote = event.symbol;
      if (event.symbol === '') {
        this.initBillet();
      }
      this.setQuote(event.symbol);
    }
  }

  getPositionOfQuote(maket: any, symbol: string) {
    this.oldPositionSymbol = symbol;
    const account = this._configService.getBrokerAccountSelected();
    try {
      if (maket === Constants.MARKET_CODE_BMF) {
        this._authServer.iNegotiation.positionBmf(account, symbol)
          .subscribe((response) => {
            if (response.custodyBovespa && response.custodyBovespa.length > 0) {
              const temp = {
                currentQuantity: response.custodyBovespa[0].currentQuantity.value,
                quantityReleased: response.custodyBovespa[0].quantityReleased.value
              };
              this.listPosition = temp;
            }
          });
      }
      if (maket === Constants.MARKET_CODE_BOVESPA) {
        symbol = symbol.substring(symbol.length - 1).toUpperCase() === 'F' ? symbol.substring(0, symbol.length - 1).toUpperCase() : symbol;
        this._authServer.iNegotiation.positionBovespa(account, symbol)
          .subscribe((response) => {
            if (response.custodyBovespa && response.custodyBovespa.length > 0) {
              const temp = {
                currentQuantity: response.custodyBovespa[0].currentQuantity.value,
                quantityReleased: response.custodyBovespa[0].quantityReleased.value
              };
              this.listPosition = temp;
            }
          });
      }
    } catch (error) {
      this.listPosition = null;
    }
  }

  setQuote(symbol: string) {
    this.oldSymbolTemp = this.symbol;
    symbol = AppUtils.trimStart(symbol);
    this.symbol = symbol;
    if (this.oldSymbolTemp && symbol && this.oldSymbolTemp.toLowerCase() === symbol.toLowerCase() && this._subscriptionQuote) {
      return;
    }
    if (this.symbol.toLowerCase() === 'invalid' || symbol === '') {
      this.hiddenInvalid = false;
      this.resetQuote();
      this.symbol = '';
      return;
    }
    const msgItem = this._quoteService.subscribeQuote(this.symbol, Constants.WINDOW_NAME_BILLET_FLOAT);
    if (msgItem !== undefined && msgItem !== '') {
      this.resetQuote();
      return;
    }
    this.model.quote = symbol;
    this.model.closeConfirmation = false;
    this.loadingImgName = true;
    this._subscriptionQuote = this._quoteService.messagesQuote
      .subscribe((msg: MessageQuote) => {
        if (msg && msg.errorMessage && (this.symbol && msg.symbol.toLowerCase() === this.symbol.toLowerCase())) {
          this.hiddenInvalid = true;
          this.symbol = null;
          this.model.company = null;
          this.imgName = '';
          this.resetQuote();
          this._quoteService.unsubscribeQuote(msg.symbol.toLowerCase(), Constants.WINDOW_NAME_BILLET_FLOAT);
          this.loading = false;
        } else if (msg !== undefined && msg.symbol != null && msg.symbol === this.symbol) {
          this.messageQuote = msg;
          this.model.quotationForm = AppUtils.convertNumberAux(msg.quotationForm);
          this.model.contractMultiplier = AppUtils.convertNumberAux(msg.contractMultiplier);

          if (this.loadingImgName) {
            this.imgName = './assets/images/symbols/' + AppUtils.getImageSymbol(this.symbol, msg.marketType).toUpperCase() + '.PNG';
            this.loadingImgName = false;
          }
          this.hiddenInvalid = false;
          this.variation = this.messageQuote.variation;
          this.coinVariation = this.messageQuote.coinVariation && this.messageQuote.coinVariation.toString() !== '-'
            ? Number(this.messageQuote.coinVariation.toString().replace(',', '.')) : 0.0;
          if (this.data && this.data.price) {
            this.model.price = this.data.price;
            this.data.price = null;
            this.loadValueService = true;
          }
          if (this.data && this.data.qtd) {
            this.model.qtd = this.data.qtd;
            this.data.qtd = null;
          }
          if (this.messageQuote.lastTrade &&
            (this.messageQuote.lastTrade.toString() !== '-' && this.messageQuote.lastTrade.toString() !== '0,00' && this.messageQuote.lastTrade.toString() !== '0')) {
            const tickSize = this.messageQuote.tickSize && this.messageQuote.marketType && this.messageQuote.marketType === MarketEnum.BITCOIN ? 3 :
              this.messageQuote.tickSize ? this.messageQuote.tickSize : 2;
            const lastTradeNumber = AppUtils.convertNumber(this.messageQuote.lastTrade.toString().replace('.', ''));
            this.messageQuote.lastTrade = AppUtils.convertToNumber(lastTradeNumber.toString(), tickSize);
            this.lastTrade = AppUtils.convertNumberToCurrency(lastTradeNumber, tickSize);
          } else {
            if (msg.lastTrade && (msg.lastTrade.toString() === '-' || msg.lastTrade.toString() === '0,00' || msg.lastTrade.toString() === '0')) {
              this.showVariation = false;
              msg.lastTrade = msg.previous;
              this.lastTrade = AppUtils.convertNumberToCurrency(msg.lastTrade, this.messageQuote.tickSize);
            } else {
              this.lastTrade = 0;
            }
            this.showVariation = false;
          }
          if (this.messageQuote.symbol.indexOf('win') === 0 || this.messageQuote.symbol.indexOf('wdo') === 0 ||
            this.messageQuote.symbol.indexOf('dol') === 0 || this.messageQuote.symbol.toLowerCase().indexOf('ind') === 0) {
            this.indiceFuture = true;
          } else {
            this.indiceFuture = false;
          }
          if (msg.description && msg.description !== '' && this.messageQuote.marketType === Constants.MARKET_CODE_BOVESPA) {
            this.model.company = this.messageQuote.description + ' ' + this.messageQuote.classification;
          } else {
            this.model.company = this.messageQuote.description;
          }
          if (msg.theoryPrice && (msg.theoryPrice > 0 || (msg.theoryPrice.toString() !== '-' && Number(msg.theoryPrice.toString().replace(',', '.'))))) {
            this.priceTheory = AppUtils.convertBrCurrencyToNumber(msg.theoryPrice.toString(), ',');
            this.auctionHammer = true;
            this.timeToOpen = msg.timeToOpen;
            let previousConst = 0;
            if (msg.previous && msg.previous.toString() !== '-') {
              previousConst = AppUtils.convertBrCurrencyToNumber(msg.previous.toString(), ',');
            }
            if (this.priceTheory > 0 && previousConst > 0) {
              let varTheoryTemp = ((this.priceTheory / previousConst) - 1) * 100;
              if (varTheoryTemp !== 0) {
                varTheoryTemp = Number(Number(varTheoryTemp).toFixed(2));
                this.varTheory = AppUtils.convertNumberToCurrency(varTheoryTemp, null, '');
              }
            }
          } else {
            this.priceTheory = 0;
            this.varTheory = null;
            this.timeToOpen = null;
            this.auctionHammer = false;
          }
          if (msg.dateLastNegotiation) {
            const today = this._datePipe.transform(new Date(), 'dd/MM/yyyy');
            if (today === msg.dateLastNegotiation) {
              this.showVariation = true;
            } else {
              this.showVariation = false;
            }
          } else {
            this.showVariation = true;
          }
          if (this.oldPositionSymbol !== this.symbol) {
            this.getPositionOfQuote(this.messageQuote.marketType, this.symbol);
          }
          this.model.loteDefault = this.messageQuote.loteDefault === undefined || this.messageQuote.loteDefault <= 0 ? 100 : this.messageQuote.loteDefault;
          this.model.market = this.messageQuote.marketType;
          this.loading = false;
        }
      });
  }

  resetQuote() {
    const oldSymbol = this.symbol;
    if (!oldSymbol || (this.data && oldSymbol.toLowerCase() === this.data.symbol.toLowerCase())) {
      return;
    }
    this.unsubscribeQuote();
    this.oldPositionSymbol = '';
    this.imgName = '';
    this.lastTrade = null;
    this.variation = null;
    this.loadValueService = false;
    this.messageQuote = new MessageQuote();
    this.getStrategies();
  }

  unsubscribeQuote() {
    if (this._subscriptionQuote) {
      this._subscriptionQuote.unsubscribe();
    }
    if (this._quoteService) {
      this._quoteService.unsubscribeQuote(this.symbol, Constants.WINDOW_NAME_BILLET_FLOAT);
    }
  }

  changeTabTypeOrder($event) {
    if ($event.index === 0) {
      this.model.type = TypeOrderEnum.LIMITED;
      this.model.side = SideEnum.BUY;
      this.tabChangeTypeOrder = 0;
      this.tabChangeSide = 0;
    } else {
      this.model.type = TypeOrderEnum.STOP;
      this.model.side = SideEnum.BUY;
      this.tabChangeTypeOrder = 1;
      this.tabChangeSide = 0;
    }
    this.getConfigSideColor();
  }

  changeTabSide($event, side?) {
    if (($event && $event.index === 0) || side === SideEnum.BUY) {
      this.model.side = SideEnum.BUY;
      this.tabChangeSide = 0;
    } else {
      this.model.side = SideEnum.SELL;
      this.tabChangeSide = 1;
    }
    this.loading = false;
    setTimeout(() => {
      this.getConfigSideColor();
    }, 0);
  }

  openModalConfirm(value) {
    this._dailyOrderService._showHiddenPadOrderConfirmation.next(false);
    this.model = value;
    if (this.model.side === SideEnum.BUY) {
      this.tabChangeSide = 0;
    } else {
      this.tabChangeSide = 1;
    }
    setTimeout(() => {
      this.getConfigSideColor();
    }, 0);
    if (!this.hiddenConfirmationBillet) {
      this.model.showConfirmationBillit = true;
      this.showConfirmationBillit = true;
    } else {
      this._dailyOrderService.verifyEletronicSignature(TypeOrderRequestEnum.SEND_ORDER, this.model);
    }
  }

  getConfigSideColor() {
    let element1: any;
    let element2: any;
    let element3: any;
    if (this.isThemeDark) {
      if (document.getElementsByClassName('darkTheme')[0] && document.getElementsByClassName('darkTheme')[0]
        .getElementsByClassName('typeOrderWksFloat')[0]) {
        element1 = document.getElementsByClassName('darkTheme')[0].getElementsByClassName('typeOrderWksFloat')[0]
          .getElementsByClassName('mat-tab-label-content')[0];
        element2 = document.getElementsByClassName('darkTheme')[0].getElementsByClassName('typeOrderWksFloat')[0]
          .getElementsByClassName('mat-tab-label-active')[0];
        element3 = document.getElementsByClassName('darkTheme')[0].getElementsByClassName('typeOrderWksFloat')[0]
          .getElementsByClassName('mat-tab-label-active')[0].getElementsByClassName('mat-tab-label-content')[0];
      }
    } else {
      if (document.getElementsByClassName('typeOrderWksFloat')[0]) {
        element1 = document.getElementsByClassName('typeOrderWksFloat')[0].getElementsByClassName('mat-tab-label-content')[0];
        element2 = document.getElementsByClassName('typeOrderWksFloat')[0].getElementsByClassName('mat-tab-label-active')[0];
        element3 = document.getElementsByClassName('typeOrderWksFloat')[0].getElementsByClassName('mat-tab-label-active')[0]
          .getElementsByClassName('mat-tab-label-content')[0];
      }
    }
    if (element1 && element2 && element3) {
      if (this.model.side === SideEnum.BUY) {
        this._render2.removeClass(element1, 'text-sell');
        this._render2.addClass(element1, 'text-buy');
        this._render2.removeClass(element2, 'border-sell');
        this._render2.addClass(element2, 'border-buy');
        this._render2.removeClass(element3, 'text-sell');
        this._render2.addClass(element3, 'text-buy');
      } else {
        this._render2.removeClass(element1, 'text-buy');
        this._render2.addClass(element1, 'text-sell');
        this._render2.removeClass(element2, 'border-buy');
        this._render2.addClass(element2, 'border-sell');
        this._render2.removeClass(element3, 'text-buy');
        this._render2.addClass(element3, 'text-sell');
      }
    }
  }

  setLoading(value) {
    this.loading = value;
  }

  closeModalConfirm(value) {
    this.showConfirmationBillit = value;
  }

  @HostListener('document:keydown.escape')
  close() {
    if (this.showTermOperator || this.showConfirmationBillit) {
      this.showTermOperator = false;
      this.showConfirmationBillit = false;
      this.model.closeConfirmation = true;
      setTimeout(() => {
        this.getConfigSideColor();
      }, 0);
    } else {
      this.dialog.closeAll();
    }
  }

  callAlert(title, message, typeAlert) {
    this._configService.systemNotificationMessage(title, message, typeAlert);
  }

  stopPropagation() {
    event.stopPropagation();
  }

  showHiddenConfirmationBilliet() {
    this.hiddenConfirmationBillet = !this.hiddenConfirmationBillet;
  }

}
